export const form = {
  addField: "Add field",
  addGroup: "Add group",
  addSeveritySection: "Add severity section",
  copyGroup: "Copy group",
  cloneSuffix: "(copy)",
  deleteGroup: "Delete group",
  editGroup: "Edit group",
  error: {
    groupAlreadyExists: "Group name already exists, please enter another name.",
    invalid: "There are some errors in the form.",
    genericError: "An error occurred",
  },
  expression: {
    calculation_detail: "Calculation detail",
  },
  formEditor: "Form editor",
  jsonEditor: "JSON editor",
  maxChar: "Character limit",
  preview: "Preview",
  severityGrid: {
    groupName: "Severity",
  },
  staticField: {
    component: {
      label: "Component",
      placeholder: "Choose the component",
      mainLevelSample: "Component",
      subLevelSample: "Sub-component",
    },
    material: {
      label: "Material",
      placeholder: "Choose the material of the defect",
    },
    defect: {
      label: "Defect",
      placeholder: "Choose a defect",
      dynamicValues: "Available choices depend on material…",
    },
    defectSuggestion: {
      label: "Suggestions:",
      placeholder: "Choose a suggested defect",
      confidence: "confidence",
      warning: "prediction has a confidence of only",
      decisionTool: "Decision Support Tool",
      decisionToolHelp: "Help",
      error: {
        noSuggestionFound: "No suggestion found.",
        materialNotSupported:
          "Cannot compute suggestions, material doesn't support suggestions.",
        noImage:
          "Cannot compute suggestions, no image associated with observation.",
      },
      hideSaliencyMap: "Hide saliency map",
      showSaliencyMap: "Show saliency map",
    },
    severity: {
      label: "Severity",
      placeholder: "Choose a severity",
      dynamicValues: "Available choices depend on defect…",
      formEditorSample: {
        name: "Level {{level}}",
        description:
          "This is the long description of the level {{level}}. This gives more information about the level number {{level}} and how to use it.",
        descriptionForDisabled:
          "Level {{level}} is disabled. This can happen when you want to restrict the possible choices for a defect in a severity grid.",
      },
      levels: {
        1: "Good",
        2: "Low",
        3: "Moderate",
        4: "Severe",
        5: "Very severe",
      },
      disabledLevel:
        "Criterion not available for the selected material and defect combination.",
    },
    probability: {
      label: "Probability of failure",
      placeholder: "Choose a probability",
      levels: {
        1: "Rare",
        2: "Unlikely",
        3: "Possible",
        4: "Likely",
        5: "Almost certain",
      },
    },
    consequence: {
      label: "Consequence of failure",
      placeholder: "Choose a consequence",
      levels: {
        1: "Very low",
        2: "Low",
        3: "Moderate",
        4: "High",
        5: "Very high",
      },
    },
    risk: {
      label: "Risk",
      placeholder: "Choose a risk",
      levels: {
        1: "Low",
        2: "Medium",
        3: "High",
        4: "Very high",
        5: "Critical",
      },
    },
  },
  severityGridEditor: {
    title: "Severity grid",
    steps: {
      defectTreeEditor: "Defects tree",
      translation: "Component's translation",
      severityGridsListTable: "Severity grid list",
    },
  },
  templateEditor: "Template editor",
  values: "Choices",
  validateMessages: {
    required: "This field is required",
    string: {
      max: "This field must be up to ${max} characters",
    },
  },
  components: {
    placeholder: "Choose a component",
    placeholderSubcomponent: "Choose a sub component",
  },
  choicesDialog: {
    title: "Select among the following {{count}} values:",
  },
};
